import { Log } from '@core';
import { filter, first, Observable, of, switchMap, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { PushPermissionsStatusCommandHandler } from '@notifications';

export class SetupAlertsStep extends StartupStep {
  private readonly pushPermissionsStatusCommandHandler: PushPermissionsStatusCommandHandler = inject(
    PushPermissionsStatusCommandHandler
  );

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'SetupAlertsStep START' });
    state.authed$
      ?.pipe(
        filter(Boolean),
        first(),
        switchMap(() => this.pushPermissionsStatusCommandHandler.setValue()),
        tap(() => this.logger.log(Log.Startup, { message: 'SetupAlertsStep COMPLETED' }))
      )
      .subscribe();

    return of(state);
  }
}
